import SuratJalanDeliverySubconDetail from '@/models/SuratJalanDeliverySubcon/SuratJalanDeliverySubconDetail';

export default class SuratJalanDeliverySubconDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.suratJalanDeliverySubconId  = '';
		this.suratJalanDeliverySubconSuratJalanNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.orderQty = '';
		this.deliveryQty = '';
		this.deliveryInstructionSubconDetailId  = '';
		this.deliveryInstructionSubconDetailPart = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			suratJalanDeliverySubconId : '0',
			suratJalanDeliverySubconSuratJalanNumber : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			orderQty : '0',
			deliveryQty : '0',
			deliveryInstructionSubconDetailId : '0',
			deliveryInstructionSubconDetailPart : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}